import axios from 'axios';

let apiKey = '616b8b9d59c400982ef61d34324bbac6';

let Vagalume = {}

let url = 'https://api.vagalume.com.br/search.php';

Vagalume.searchLyrics = function(artist, track, cb){

  let params = {art: artist, mus: track, apiKey};

  return axios({method: 'get', url, params})
  .then((response) => {
    let data = response.data;
    return({url: data.mus[0].url, lines: data.mus[0].text.split('\n')});
  });

};

module.exports = Vagalume


// WEBPACK FOOTER //
// ./src/js/services/vagalume.js